(function($) {
  'use strict';

  const amenities = {
    dom: function() {
      this.$image = $('.amenities__group-image-asset');
    },

    slideActions: function() {
      this.$image.each(function() {
        const src = $(this).attr('data-src');
        $(this).closest('.amenities__group-image').css('background-image', 'url("' + src + '")');
      });
    },

    ready: function() {
      this.dom();
      this.slideActions();
    }
  };

  $(function() { amenities.ready(); });

})(jQuery);
